module.exports = __webpack_public_path__ + "img/amy.884c1ec2.png";